import { schemas } from '#oaf_schema.registry';
import { securityReviewStore } from '.';
import { selectSecurityReview } from './securityReviewStoreSelectors';
const selectors = {
  selectTechnologyDetails(state, isDraftState) {
    var _selectSecurityReview;
    const pluginType = 'securityReview/plugins/TechnologyDetails';
    let plugin = (_selectSecurityReview = selectSecurityReview(state)) === null || _selectSecurityReview === void 0 ? void 0 : _selectSecurityReview.plugins.find(test => test.pluginType === pluginType);
    let techDetails;
    if (!plugin) {
      plugin = securityReviewStore.upsertPlugin({
        pluginType,
        data: schemas[pluginType].new({
          includesRequiresWebSvc: true,
          useOtherPlatform: true,
          integratesWithExternalTech: true,
          isApiOnly: false,
          isJapaneseSolution: false,
          containsSFTech: true,
          storesAuthToken: true,
          storesOutsideSF: true,
          isMobileAppAvailable: true,
          devicesTarget: true,
          includesBrowserExtension: true,
          includesClientApp: true
        })
      }, isDraftState ? selectSecurityReview(state) : undefined);
      //Default all toggles to ON
      techDetails = plugin.data;
      techDetails.includesRequiresWebSvc = true;
      techDetails.useOtherPlatform = true;
      techDetails.integratesWithExternalTech = true;
      techDetails.isApiOnly = false;
      techDetails.isJapaneseSolution = false;
      techDetails.containsSFTech = true;
      techDetails.storesAuthToken = true;
      techDetails.storesOutsideSF = true;
      techDetails.isMobileAppAvailable = true;
      techDetails.devicesTarget = true;
      techDetails.includesBrowserExtension = true;
      techDetails.includesClientApp = true;
    } else {
      techDetails = plugin.data;
    }
    return techDetails;
  }
};
export const {
  selectTechnologyDetails
} = selectors;
export default function actions(set) {
  return {
    setTechnicalDescription(techDesciption) {
      set(function setTechnicalDescription(draft) {
        selectTechnologyDetails(draft, true).technicalDescription = techDesciption;
      });
    },
    setRequireWebAppOrWebServices(includeWebAppOrServices) {
      set(function setRequireWebAppOrWebServices(draft) {
        selectTechnologyDetails(draft, true).includesRequiresWebSvc = includeWebAppOrServices;
      });
    },
    setWebAppOrServiceDetails(webAppOrWebServicesDetails) {
      set(function setWebAppOrServiceDetails(draft) {
        selectTechnologyDetails(draft, true).includesRequiresWebSvcDetails = webAppOrWebServicesDetails;
      });
    },
    setRequireUseOtherPlatform(includeUseOtherPlatform) {
      set(function setRequireUseOtherPlatform(draft) {
        selectTechnologyDetails(draft, true).useOtherPlatform = includeUseOtherPlatform;
      });
    },
    setUserOtherPlatformDetails(useOtherPlatformDetails) {
      set(function setUserOtherPlatformDetails(draft) {
        selectTechnologyDetails(draft, true).useOtherPlatformDetails = useOtherPlatformDetails;
      });
    },
    setRequireIntegratesWithExternalTech(includeIntegrationExternalTech) {
      set(function setRequireIntegratesWithExternalTech(draft) {
        selectTechnologyDetails(draft, true).integratesWithExternalTech = includeIntegrationExternalTech;
      });
    },
    setIntegratesWithExternalTech(integrateWithExternalTech) {
      set(function setIntegratesWithExternalTech(draft) {
        selectTechnologyDetails(draft, true).integratesWithExternalTechDetails = integrateWithExternalTech;
      });
    },
    setIsAPIOnly(onlyAPI) {
      set(function setIsAPIOnly(draft) {
        selectTechnologyDetails(draft, true).isApiOnly = onlyAPI;
      });
    },
    setIsJapaneseSolution(japaneseSolution) {
      set(function setIsJapaneseSolution(draft) {
        selectTechnologyDetails(draft, true).isJapaneseSolution = japaneseSolution;
      });
    },
    setRequiresSFTech(containsSFTech) {
      set(function setRequiresSFTech(draft) {
        selectTechnologyDetails(draft, true).containsSFTech = containsSFTech;
      });
    },
    setContainsSFTechDetails(containsSFTechDetails) {
      set(function setContainsSFTechDetails(draft) {
        selectTechnologyDetails(draft, true).containsSFTechDetails = containsSFTechDetails;
      });
    },
    setRequiresStoreAuthToken(storeAuthToken) {
      set(function setRequiresStoreAuthToken(draft) {
        selectTechnologyDetails(draft, true).storesAuthToken = storeAuthToken;
      });
    },
    setStoreAuthTokenDetails(storesAuthTokenDeatils) {
      set(function setStoreAuthTokenDetails(draft) {
        selectTechnologyDetails(draft, true).storesAuthTokenDetails = storesAuthTokenDeatils;
      });
    },
    setRequiresStoreOutsideSF(storeOutsideSF) {
      set(function setRequiresStoreOutsideSF(draft) {
        selectTechnologyDetails(draft, true).storesOutsideSF = storeOutsideSF;
      });
    },
    setStoresOutsideSFDetails(storeOutsideSFDetails) {
      set(function setStoresOutsideSFDetails(draft) {
        selectTechnologyDetails(draft, true).storesOutsideSFDetails = storeOutsideSFDetails;
      });
    },
    setIsMobileAppAvailable(isMobileAppAvailable) {
      set(function setIsMobileAppAvailable(draft) {
        selectTechnologyDetails(draft, true).isMobileAppAvailable = isMobileAppAvailable;
      });
    },
    setRequiresDevicesTarget(requiresDevicesTarget) {
      set(function setRequiresDevicesTarget(draft) {
        selectTechnologyDetails(draft, true).devicesTarget = requiresDevicesTarget;
      });
    },
    setDevicesTargetDetails(devicesTargetDetails) {
      set(function setDevicesTargetDetails(draft) {
        selectTechnologyDetails(draft, true).devicesTargetDetails = devicesTargetDetails;
      });
    },
    setRequiresBrowserExtensions(requiresBrowserExtensions) {
      set(function setRequiresBrowserExtensions(draft) {
        selectTechnologyDetails(draft, true).includesBrowserExtension = requiresBrowserExtensions;
      });
    },
    setBrowserExtensionsDetails(browserExtensionDetails) {
      set(function setBrowserExtensionsDetails(draft) {
        selectTechnologyDetails(draft, true).browserExtensionDetails = browserExtensionDetails;
      });
    },
    setRequiresClientApp(requiresClientApp) {
      set(function setRequiresClientApp(draft) {
        selectTechnologyDetails(draft, true).includesClientApp = requiresClientApp;
      });
    },
    setClientAppDetails(clientAppDetails) {
      set(function setClientAppDetails(draft) {
        selectTechnologyDetails(draft, true).clientAppDetails = clientAppDetails;
      });
    },
    saveOnlyTechDetailsToggleOn() {
      set(function saveOnlyToggleOn(state) {
        if (!selectTechnologyDetails(state).includesRequiresWebSvc) selectTechnologyDetails(state, true).includesRequiresWebSvcDetails = '';
        if (!selectTechnologyDetails(state).useOtherPlatform) selectTechnologyDetails(state, true).useOtherPlatformDetails = '';
        if (!selectTechnologyDetails(state).integratesWithExternalTech) selectTechnologyDetails(state, true).integratesWithExternalTechDetails = '';
        if (!selectTechnologyDetails(state).containsSFTech) selectTechnologyDetails(state, true).containsSFTechDetails = '';
        if (!selectTechnologyDetails(state).storesAuthToken) selectTechnologyDetails(state, true).storesAuthTokenDetails = '';
        if (!selectTechnologyDetails(state).storesOutsideSF) selectTechnologyDetails(state, true).storesOutsideSFDetails = '';
        if (!selectTechnologyDetails(state).devicesTarget) selectTechnologyDetails(state, true).devicesTargetDetails = '';
        if (!selectTechnologyDetails(state).includesBrowserExtension) selectTechnologyDetails(state, true).browserExtensionDetails = '';
        if (!selectTechnologyDetails(state).includesClientApp) selectTechnologyDetails(state, true).clientAppDetails = '';
      });
    }
  };
}